import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { styled } from 'styled-components';
import { InteractionType, } from '@debbie/common/dist/interactions/index.js';
import { Table, Modal, Button } from '../../index.js';
import { APIBASE } from '../../../config.js';
import ButtonDrop from '../../ButtonDrop.js';
import { Meta } from './style.js';
import ObjectComp from '../../ObjectComp.js';
export const InteractionDetails = (props) => {
    const lang = useSelector((s) => s.lang);
    const [showInteractionOpen, setShowInteractionOpen] = useState(false);
    const [open, setOpen] = useState(false);
    return (React.createElement(React.Fragment, null,
        React.createElement(ButtonDrop, { open: showInteractionOpen, onOpen: () => setShowInteractionOpen(true), onClose: () => setShowInteractionOpen(false), size: "mini", info: true, maxWidth: "500px", minWidth: "500px" },
            React.createElement(Meta, null,
                React.createElement(Table, { zebra: true },
                    props.details.type && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.type)),
                        React.createElement("td", null, lang.interactionTypes[props.details.type] || props.details.type))),
                    [
                        InteractionType.Note,
                        InteractionType.ClientNote,
                        InteractionType.DebtorNote,
                        InteractionType.Phone,
                    ].includes(props.details.type) && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.content)),
                        React.createElement("td", null, props.details.notes &&
                            props.details.notes
                                .split('\n')
                                .map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                                item,
                                React.createElement("br", null))))))),
                    [InteractionType.Phone].includes(props.details.type) && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.phoneNumber)),
                        React.createElement("td", null, props.details.details.phone.number &&
                            props.details.details.phone.locale &&
                            '+' +
                                props.details.details.phone.locale +
                                ' ' +
                                props.details.details.phone.number))),
                    [InteractionType.SMS].includes(props.details.type) && (React.createElement(React.Fragment, null,
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("b", null, lang.blameLogs.content)),
                            React.createElement("td", null, props.details.details.text &&
                                props.details.details.text
                                    .split('\n')
                                    .map((item, index) => (React.createElement(React.Fragment, { key: item + index },
                                    item,
                                    React.createElement("br", null)))))),
                        React.createElement("tr", null,
                            React.createElement("td", null,
                                React.createElement("b", null, lang.blameLogs.phoneNumber)),
                            React.createElement("td", null, props.details.details.number &&
                                props.details.details.countryCode &&
                                '+' +
                                    props.details.details.countryCode +
                                    ' ' +
                                    props.details.details.number)))),
                    [InteractionType.Email].includes(props.details.type) && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.subject)),
                        React.createElement("td", null, props.details.details.subject &&
                            props.details.details.subject))),
                    [InteractionType.Letter].includes(props.details.type) && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.content)),
                        React.createElement("td", null,
                            React.createElement(Button, { size: "mini", onClick: () => {
                                    setOpen(!open);
                                } }, lang.blameLogs.viewLetter)))),
                    props.details.chainInfo?.chaintitle && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.chainTitle)),
                        React.createElement("td", null, props.details.chainInfo.chaintitle))),
                    props.details.chainInfo?.steptitle && (React.createElement("tr", null,
                        React.createElement("td", null,
                            React.createElement("b", null, lang.blameLogs.stepTitle)),
                        React.createElement("td", null, props.details.chainInfo.steptitle)))))),
        open && (React.createElement(ModalContainer, null,
            React.createElement(Modal, { header: lang.interactionTypes.LETTER, onToggle: () => {
                    setOpen(!open);
                } },
                React.createElement(ObjectComp, { type: "application/pdf", url: `${APIBASE}/files/${props.details.details.pdf}/debbie.pdf` }))))));
};
const ModalContainer = styled.div `
  text-align: left;
`;
//# sourceMappingURL=InteractionDetails.js.map